import moment from 'moment-timezone';

export function combineDateTime(transaction, timezone = 'Asia/Riyadh') {

    const dateMoment = moment(transaction.date);
    const timeMoment = moment(transaction.time, 'HH:mm');

    if (!dateMoment.isValid() || !timeMoment.isValid()) {

        return false;
    }

    const date = dateMoment.format('YYYY-MM-DD');
    const time = timeMoment.format('HH:mm');

    const dateTime = moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss');

    return moment.tz(dateTime, timezone).utc().format('YYYY-MM-DD HH:mm:ss');
}

export function setTimeZone(dateTime, timezone) {

    return moment(moment.tz(dateTime, timezone).format('YYYY-MM-DD HH:mm:ss'));
}



// WEBPACK FOOTER //
// ./src/app/helpers/date-time-helper.js